<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (hasError) {
	<div class="table-error">
		<span class="icon-unlink"></span>

		<span class="message">Unable to load the data, please retry or contact support</span>

		<globalictcc-button
			label="Retry"
			iconName="update"
			[textOnly]="true"
			(handleClick)="handleTableRefresh.emit()"
		/>
	</div>
} @else {
	<ag-grid-angular
		class="grid-wrapper"
		[ngStyle]="{ height: gridHeight + 'px' }"
		[gridOptions]="gridOptions"
	/>
}
